<template>
  <base-jin-nang-panel :title="headTitle">
    <template v-slot:bodyContent>
      <base-jin-nang-table :titleList="titleList" :dataList="dataList">
        <template v-slot:operation="{ item }">
          <td class="operation-cell">
            <div
              v-if="item.statusMsg !== '已撤单'"
              class="cancleBtn"
              @click="secuCancle(item)"
            >
              撤单
            </div>
          </td>
        </template>
      </base-jin-nang-table>
    </template>
  </base-jin-nang-panel>
</template>

<script>
import BaseJinNangPanel from '../BaseJinnangPanel/BaseJinNangPanel.vue'
import BaseJinNangTable from '../BaseJinNangTable/BaseJinNangTable.vue'
import {
  getAuthorJinNangTradePage,
  authorJinNangSecuCancle
} from '@/api/AuthorJinNang'
import dayjs from 'dayjs'

export default {
  name: 'AuthorJinNangCancle',
  components: { BaseJinNangPanel, BaseJinNangTable },
  data() {
    return {
      titleList: [
        { text: '委托类型', class: '' },
        { text: '证券代码', class: '' },
        { text: '证券名称', class: '' },
        { text: '委托时间', class: 'width100px' },
        { text: '委托价格', class: '' },
        { text: '委托数量', class: '' },
        { text: '委托金额', class: '' },
        { text: '状态', class: '' },
        { text: '操作', class: '' }
      ],
      headTitle: '撤单',
      pageSize: 1000,
      pageIndex: 0,
      total: 0,
      orderby: 'desc',
      viewState: '',
      pageEnd: true,
      tradeList: []
    }
  },
  created() {
    this.getTradePage()
  },
  computed: {
    currentJinNangId() {
      return this.$route.params.id
    },
    dataList() {
      if (this.tradeList) {
        return this.tradeList
          .filter(a => a.tradeType !== 4) // 撤单的不显示
          .map(a => ({
            tr: a,
            tds: [
              { text: a.tradeTypeName, class: '' },
              { text: a.secuCode, class: '' },
              { text: a.secuName, class: '' },
              { text: this.formatTime(a.entrustTime), class: 'width100px' },
              { text: a.entrustPrice / 10000, class: '' },
              { text: a.entrustAmt, class: '' },
              { text: (a.entrustPrice * a.entrustAmt) / 10000, class: '' },
              { text: a.statusMsg, class: '' }
            ]
          }))
      } else {
        return []
      }
    }
  },
  methods: {
    async getTradePage() {
      const data = await getAuthorJinNangTradePage(
        {
          pageSize: this.pageSize,
          jinNangId: this.currentJinNangId,
          filter: 2,
          beginTime: 0,
          endTime: 0
        },
        this.viewState
      )
      if (data && data.result.code === 0) {
        this.tradeList = data.detail.list
      }
    },
    async secuCancle(item) {
      this.$confirm('即将提交撤单请求, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          this.dosecuCancle(item)
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消撤单请求'
          })
        })
    },

    async dosecuCancle(item) {
      const data = await authorJinNangSecuCancle({
        jinNangId: this.currentJinNangId,
        entrustNo: item.entrustNo
      })
      if (data && data.result.code === 0) {
        this.$message({
          type: 'success',
          message: '撤单成功!'
        })
        this.getTradePage()
      } else {
        this.$message.error(data.result.msg || '撤单失败')
      }
    },
    formatTime(time) {
      return dayjs(time).format('YYYY-MM-DD HH:mm:ss')
    }
  }
}
</script>

<style lang="scss" scoped>
.operation-cell {
  width: 120px;
}
.cancleBtn {
  width: 60px;
  height: 24px;
  background-color: rgba(4, 107, 204, 0.1);
  border-radius: 12px;
  font-family: MicrosoftYaHei;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 24px;
  letter-spacing: 1px;
  text-align: center;
  color: #046bcc;
  margin: auto;
  cursor: pointer;
}
</style>
